let selectors = {
  modal: document.querySelector('.enquiryModal'),
  modalTitle: document.querySelector('.enquiryModal__title'),
  form: document.querySelector('.enquiryModal__form'),
  enquireBtn: document.querySelectorAll('.enquiryModal-trigger'),
  closeEnquireModalBtn: document.querySelector('.enquiryModal__close'),
  submit: document.querySelector('.enquiryModal__submit'),
  getInterestedInField: document.querySelector('input[name="input_12"]'),
  activeState: 'enquiryModal--active'
};

const toggleModalVisibility = () => {
  let { modal, activeState } = selectors;
  modal.classList.add(activeState);
}

const watchForModalEvents = () => {

  let { closeEnquireModalBtn,
    modalTitle,
    getInterestedInField,
    modal,
    activeState
  } = selectors;

  Array.prototype.forEach.call(document.querySelectorAll('.enquiryModal-trigger'), (trigger) => {

    trigger.addEventListener('click', () => {

      if (trigger.dataset.title) {
        getInterestedInField.value = trigger.dataset.title;
        trigger.dataset.title.match(/[a-z]/i) ? modalTitle.innerHTML = trigger.dataset.title : modalTitle.innerHTML = `Plot ${trigger.dataset.title}`;
      }

      toggleModalVisibility();

    });

    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('enquiry')) {
      trigger.click();
    }

  });

  closeEnquireModalBtn.addEventListener('click', () => modal.classList.remove(activeState));

  document.addEventListener('keydown', (e) => {
    if (modal.classList.contains(activeState)) {
      if (e.key === "Escape") modal.classList.remove(activeState)
    }
  });

  document.addEventListener('click', (e) => {
    if (modal.classList.contains(activeState))
    if (e.target.classList.contains('enquiryModal')) modal.classList.remove(activeState)
  });

  let hasErrors = document.querySelector('.enquiryModal .gfield_error');

  if (typeof hasErrors != "undefined" && hasErrors != null) {
    toggleModalVisibility();
  }

}

const EnquiryModalComponent = () => watchForModalEvents();

export default EnquiryModalComponent;


// WEBPACK FOOTER //
// ./src/js/app/components/EnquiryModal.js